import { configureStore } from "@reduxjs/toolkit";
import { CompanySlice } from "./company";
import { UserActionDataSlice } from "./userActionData";
import { UserSlice } from "./user";
import { combineReducers } from "@reduxjs/toolkit";
import { MenuSlice } from "./menu";
import { countrySlice } from "./country";
const reducers = combineReducers({
  company: CompanySlice.reducer,
  menu: MenuSlice.reducer,
  actionData: UserActionDataSlice.reducer,
  user: UserSlice.reducer,
  country: countrySlice.reducer,
});

export const store = configureStore({
  reducer: reducers,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
